// HomePage.tsx
import React, { useState } from 'react';
import ShareLinkDialog from '../dialog/ShareLinkDialog';
import { Reply as ReplyIcon } from '@mui/icons-material';
interface ShareLinkProps {
    urlToShare: string;
    type?: string;
}

const ShareLink: React.FC<ShareLinkProps> = ({ urlToShare, type="" }) => {
    const [shareDialogOpen, setShareDialogOpen] = useState(false);
    const handleOpenShareDialog = () => {
        setShareDialogOpen(true);
    };

    const handleCloseShareDialog = () => {
        setShareDialogOpen(false);
    };

    return (
        <div>
            <ReplyIcon onClick={handleOpenShareDialog} />
            <ShareLinkDialog open={shareDialogOpen} onClose={handleCloseShareDialog} url={urlToShare} type={type} />
        </div>
    );
};

export default ShareLink;
